import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UnlServiceService } from 'src/app/services/unl-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-menu-mobile',
  templateUrl: './side-menu-mobile.component.html',
  styleUrls: ['./side-menu-mobile.component.scss']
})
export class SideMenuMobileComponent {

  envType = environment.environmentType;

  @Input() menus = [];
  @Input() termId = '';

  @Input() rightmenuCurrent = ''

  @Output() rightMenuEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() toggleMenuEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() setRighMenuetActive: EventEmitter<any> = new EventEmitter<any>();
  ctype: any;

  constructor(public unlService: UnlServiceService,  private router: Router) { }

  rightMenuClick(rMenu: any, rmi: any) {
    this.rightMenuEvent.emit({
      rMenu: rMenu,
      rmi: rmi
    });
  }

  toggleMenu(type: any) {
    this.ctype = type;
    this.toggleMenuEvent.emit();
  }
  

}
